import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home';
import Error from './pages/error';

import './pages/general.css'
import About from './pages/about';
import Book from './pages/book';
import Details from './pages/Details';
import VRViewer from './components/layout/vr';
import Exhibation from './pages/exbation';
import Gsap from './components/layout/gsap';


const Routess = () => {
  return (

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/book" element={<Book />} />
        <Route path="/details" element={<Details />} />
        <Route path="/exhibtor" element={<Exhibation />} />
        <Route path="/vr-viewer" element={<VRViewer />} />
        <Route path="/gsap" element={<Gsap />} />


        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routess;